"use strict";

exports.__esModule = true;
exports.createTimer = createTimer;
var _createClock = require("./createClock");
var BASE_INTERVAL = 25;
var clock = (0, _createClock.createClock)(BASE_INTERVAL);

/**
 * Create a timer which will invoke the given callback every N seconds.
 * This is similar to `setInterval`, but differs in three ways:
 * - It does not suffer from the same flaws as `setInterval`,
 *   as it's using `setTimeout` under the hood.
 * - Instead of returning a numerical id it returns an unsubscribe function.
 * - All timers use a shared clock.
 */
function createTimer(callback, interval) {
  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }
  var normalizedInterval = Math.round(interval / BASE_INTERVAL) * BASE_INTERVAL;
  var targetCount = normalizedInterval / BASE_INTERVAL;
  var count = 0;
  return clock.subscribe(function () {
    count++;
    if (count >= targetCount) {
      count = 0;
      callback.apply(void 0, params);
    }
  });
}